import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Link as RouterLink,
  Routes,
  useLocation,
} from "react-router-dom";
import BrandsMetadataTable from "../../components/Brand/Reports/BrandsMetadataTable";
import BrandsSummaryTable from "../../components/Brand/Reports/BrandsSummaryTable";
import NameRecurrencesReview from "../../components/Brand/Tagging/NameRecurrencesReview";
import LoremJokesumPlaceholder from "../../components/UI/LoremIpsumPlaceholder";

const DataOpsBrandsPage: React.FC<{}> = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");

  const tabs = [
    { path: "/data-ops/brands/summary", name: "Summary" },
    { path: "/data-ops/brands/metadata", name: "Metadata" },
    { path: "/data-ops/brands/ownership", name: "Ownership" },
    { path: "/data-ops/brands/tagging", name: "Tagging" },
  ];

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `DataOps Brands - ${selectedTabName}`;
  }, [selectedTabName]);

  return (
    <Box>
      <h1>DataOps Brands</h1>

      {/* Tabs navigation */}
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>

      {/* Routes to render content */}
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/data-ops/brands/summary" replace={true} />}
        />

        <Route path="summary" element={<BrandsSummaryTable />} />
        <Route path="metadata" element={<BrandsMetadataTable />} />
        <Route
          path="ownership"
          element={
            <LoremJokesumPlaceholder
              question="Why did the math book look sad?"
              answer="Because it had too many problems."
            />
          }
        />
        <Route path="tagging" element={<NameRecurrencesReview />} />
      </Routes>
    </Box>
  );
};

export default DataOpsBrandsPage;
